import { exists } from '@/api'

export interface SystemGroup {
  id: number
  name: string
  lending: SystemGroupSelectType1
  return: SystemGroupSelectType1
  bibliography: SystemGroupSelectType2
  user: SystemGroupSelectType2
  reference: SystemGroupSelectType1
  operationMenuId: number
  operationMenuName: string
  topMenuId: number
  topMenuName: string
  batchMenuId: number
  batchMenuName: string
  sessionTimeoutMinutes: number
  revision: number
}

export const SystemGroupSelectType1 = {
  Disallowed: 0,
  Allowed: 1
}
export type SystemGroupSelectType1 = typeof SystemGroupSelectType1[keyof typeof SystemGroupSelectType1]

export const SystemGroupSelectType2 = {
  Disallowed: 0,
  Allowed: 1,
  OnlyReference: 2
}
export type SystemGroupSelectType2 = typeof SystemGroupSelectType2[keyof typeof SystemGroupSelectType2]

export const defaultSystemGroup = (): SystemGroup => ({
  id: 0,
  name: '',
  lending: SystemGroupSelectType1.Allowed,
  return: SystemGroupSelectType1.Allowed,
  bibliography: SystemGroupSelectType2.Allowed,
  user: SystemGroupSelectType2.Allowed,
  reference: SystemGroupSelectType1.Allowed,
  operationMenuId: 0,
  operationMenuName: '',
  topMenuId: 0,
  topMenuName: '',
  batchMenuId: 0,
  batchMenuName: '',
  sessionTimeoutMinutes: 0,
  revision: 0
})

export function SystemGroupFromJSON(json: any): SystemGroup {
  return {
    id: exists(json, 'id') ? json.id : 0,
    name: exists(json, 'name') ? json.name : '',
    lending: exists(json, 'lending')
      ? json.lending
      : SystemGroupSelectType1.Allowed,
    return: exists(json, 'return')
      ? json.return
      : SystemGroupSelectType1.Allowed,
    bibliography: exists(json, 'bibliography')
      ? json.bibliography
      : SystemGroupSelectType2.Allowed,
    user: exists(json, 'user') ? json.user : SystemGroupSelectType2.Allowed,
    reference: exists(json, 'reference')
      ? json.reference
      : SystemGroupSelectType1.Allowed,
    operationMenuId: exists(json, 'operation_menu_id')
      ? json.operation_menu_id
      : 0,
    operationMenuName: exists(json, 'operation_menu_name')
      ? json.operation_menu_name
      : '',
    topMenuId: exists(json, 'top_menu_id') ? json.top_menu_id : 0,
    topMenuName: exists(json, 'top_menu_name') ? json.top_menu_name : '',
    batchMenuId: exists(json, 'batch_menu_id') ? json.batch_menu_id : 0,
    batchMenuName: exists(json, 'batch_menu_name') ? json.batch_menu_name : '',
    sessionTimeoutMinutes: exists(json, 'session_timeout_minutes')
      ? json.session_timeout_minutes
      : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
